import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialComponentsModule } from '../shared/material-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { EventsListComponent } from './list/events-list.component';
import { EventsRoutingModule } from './events-routing.module';
import { EventsDetailComponent } from './detail/events-detail.component';
import { EventsComponent } from './events.component';
import { RegisterEventComponent } from './register/event-register.component';
import { AngularFileUploaderModule } from 'angular-file-uploader';
import { EventsRankComponent } from './rank/events-rank.component';
import { EventsClassComponent } from './classing/events-class.component';

@NgModule({
  declarations: [
    EventsComponent,
    EventsDetailComponent,
    EventsListComponent,
    RegisterEventComponent,
    EventsRankComponent ,
    EventsClassComponent
  ],
  imports: [
    CommonModule,
    EventsRoutingModule,
    MaterialComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    AngularFileUploaderModule
  ]
})
export class EventsModule { }
